import {
  LicenseExpiryMessages,
  PageWarningMessages,
} from "../../models/messages/Messages";
import { Button } from "../buttons/Button";
import { useLicenseDetails } from "../licensing/useLicenseDetails";
import "../../styles/stale/staleAlert.css";

export { LicenseWarning };

type Props = {
  onConfirm: (stale: boolean) => void;
};
const THIRTY_ONE_DAYS = 1000 * 60 * 60 * 24 * 31;
const LicenseWarning = (props: Props) => {
  const [licenseDetails, loading] = useLicenseDetails();
  if (loading || licenseDetails == undefined || licenseDetails.expiry == null) {
    return null;
  }

  // Page count close
  const expired = licenseDetails.expiry < Date.now();
  const expirySoon =
    !expired && licenseDetails.expiry < Date.now() + THIRTY_ONE_DAYS;
  // Page count exceeded
  if (!expired && !expirySoon) {
    return null;
  }

  return (
    <div className={"staleAlert batch"}>
      {expired && <h3>The Accelerator License Has Expired</h3>}
      {expirySoon && <h3>The Accelerator Licensed Will Expire Soon</h3>}
      <div>
        {expired && (
          <span>
            {LicenseExpiryMessages.expired(licenseDetails!.expiry ?? 0)}
          </span>
        )}
        {expirySoon && (
          <span>
            {LicenseExpiryMessages.expiresSoon(licenseDetails!.expiry ?? 0)}
          </span>
        )}

        <div className={"fluffer"} />

        {expirySoon && (
          <div className={"buttons"}>
            <Button
              data-save-changes
              onClick={() => {
                props.onConfirm(true);
              }}
            >
              OK
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
